import { faArrowsSpin } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useConfig } from '@nexelem/config';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../hooks';
import { PlanView, useProductionPlanQueryParams } from '../hooks';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../routes/config';

export const CreateSimulationButton = () => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { queryParams } = useProductionPlanQueryParams();
  const { modules } = useConfig();
  const isSimulationViewEnabled = modules.production.simulationView;

  if (!isSimulationViewEnabled || queryParams.view !== PlanView.GANTT) {
    return null;
  }

  return (
    <Button
      component={Link}
      StartIcon={<FontAwesomeIcon icon={faArrowsSpin} />}
      to={ROUTES.plan.simulationCreatePath}
      variant="outlined"
    >
      {tWrapper('createSimulation')}
    </Button>
  );
};
